export function normalizeActiveComponentsResponse(data) {
  return {
    ...data,
    items: data.items.map(({ state, component }) => ({
      ...component,
      __state: state,
    })),
  };
}
